import { useFormContext } from 'react-hook-form';
import { LwFormNumberInput } from 'redesign';

type DailyPayoutLimitField = {
  dailyPayoutAmountLimit: number;
};

export const DailyPayoutLimitInput = ({
  disabled,
  helperText,
  placeholder,
  required,
}: {
  disabled?: boolean;
  helperText?: string;
  placeholder?: string;
  required?: boolean;
}) => {
  const { control } = useFormContext<DailyPayoutLimitField>();

  return (
    <LwFormNumberInput
      name="dailyPayoutAmountLimit"
      label="Dagelijkse uitbetalingslimiet (€)"
      control={control}
      rules={{
        ...(required ? { required: 'Voer een dagelijkse uitbetalingslimiet in' } : {}),
      }}
      step={1}
      min={0}
      placeholder={placeholder}
      helperText={helperText}
      disabled={disabled}
    />
  );
};
